<div class="flex-column gap pb-3">
    <app-service-settings-common
        [defaultData]="store.doctorRecordSettings()"
        [title]="'service.settings.doctorRecord.header'"
    >
        <ng-template #additionalContent>
            <p-divider></p-divider>
            <app-check-input
                id="showNurseRecord"
                [form]="form"
                label="service.settings.doctorRecord.showNurseRecord"
            ></app-check-input>
            <div class="ml-4 grid-1col input-grid-gaps">
                <app-check-input
                    id="useVisits"
                    [form]="form"
                    label="service.settings.doctorRecord.useVisits"
                ></app-check-input>
                <app-check-input
                    id="useInterventions"
                    [form]="form"
                    label="service.settings.doctorRecord.useInterventions"
                ></app-check-input>
            </div>
            <div>{{ 'service.settings.doctorRecord.doctorDetailTitle' | translate }}</div>
            <div class="ml-4 grid-1col input-grid-gaps">
                <app-check-input
                    id="showRecordTime"
                    [form]="form"
                    label="service.settings.doctorRecord.showRecordTime"
                ></app-check-input>
                <app-check-input
                    id="showMainDiagnosis"
                    [form]="form"
                    label="service.settings.doctorRecord.showMainDiagnosis"
                ></app-check-input>
                <app-check-input
                    id="showReferringDoctor"
                    [form]="form"
                    label="service.settings.doctorRecord.showReferringDoctor"
                ></app-check-input>
            </div>
            <app-check-input
                id="showEpicrisis"
                [form]="form"
                label="service.settings.doctorRecord.showEpicrisis"
            ></app-check-input>
        </ng-template>
        <ng-template #footer>
            <app-action-buttons
                (primaryClickEvent)="save()"
                (secondaryClickEvent)="cancel()"
            ></app-action-buttons>
        </ng-template>
    </app-service-settings-common>

    <div>
        <app-service-doctor-record-type-modal></app-service-doctor-record-type-modal>
        <app-card-table
            #doctorRecordTypeTable
            [tableTitle]="'service.settings.general.doctorRecordType.label'"
            [columns]="doctorRecordTypeColumns"
            translatePrefix="service.settings.general.doctorRecordType."
            [hideCheckboxes]="true"
            [showDelete]="isAllowed['service.update']()"
            [showDetail]="isAllowed['service.update']()"
            [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [serviceId.toString()] }]]"
            [gridData]="$any(store.data.getServiceDoctorRecordTypes())"
            [refreshCallback]="store.api.getServiceDoctorRecordTypes"
            [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
            (deleteCallbackWithEvent)="deleteDoctorType($event)"
            (createCallback)="createDoctorType()"
            (detailCallback)="updateDoctorType($event)"
        >
        </app-card-table>
    </div>
</div>
